// Automations → « Processus de l'agent » (2026-10-15).
const m: Record<string, string> = {
  'Processus de l’agent': 'Agent process',
  'Version {v} active.': 'Version {v} active.',
  'Une nouvelle version ne touche que les nouvelles conversations.': 'A new version only applies to new conversations.',
  'Historique des versions': 'Version history',
  'Le moteur de l’agent n’utilise pas encore ce processus (interrupteur OFF) — rien ne change pour les clientes.': 'The agent engine does not use this process yet (switch OFF) — nothing changes for clients.',
  'Le moteur de l’agent suit ce processus.': 'The agent engine follows this process.',
  'Lecture seule : la migration 251 n’est pas encore appliquée.': 'Read-only: migration 251 is not applied yet.',
  'Versions': 'Versions',
  'Version {v}': 'Version {v}',
  'en service': 'in use',
  'Revenir à cette version': 'Go back to this version',
  'Activer la version {v} ? Elle s’appliquera aux nouvelles conversations.': 'Activate version {v}? It will apply to new conversations.',
  'Activer la version {v}': 'Activate version {v}',
  'Version {v} enregistrée — pas encore active.': 'Version {v} saved — not active yet.',
  'Parcours': 'Paths',
  '{n} étapes · {o} OFF': '{n} steps · {o} OFF',
  'Test A/B : désactivé': 'A/B test: off',
  'Ordre impossible — enregistrement bloqué.': 'Impossible order — saving blocked.',
  'L’autre onglet a aussi {n} problème(s).': 'The other tab also has {n} problem(s).',
  '{n} modification(s) non enregistrée(s)': '{n} unsaved change(s)',
  'Aucune modification': 'No changes',
  '{n} modif.': '{n} change(s)',
  'Arrive avec le plan 3': 'Coming with plan 3',
  'Tester dans le simulateur': 'Test in the simulator',
  'Qu’est-ce qui change dans cette version ?': 'What changes in this version?',
  'Enregistrer la version {v}': 'Save version {v}',
  'Chargement…': 'Loading…',
  'Lecture impossible :': 'Could not read:',
  // The list
  'Étapes dans l’ordre': 'Steps in order',
  'Relances {h} h': 'Reminders {h} h',
  'Ignorée : vient de Shopify': 'Skipped: comes from Shopify',
  'ignorée si déjà connu': 'skipped if already known',
  'Monter « {x} »': 'Move « {x} » up',
  'Descendre « {x} »': 'Move « {x} » down',
  'verrouillée': 'locked',
  '« {x} » activée': '« {x} » on',
  'Agent': 'Agent', 'Client': 'Client', 'Vous': 'You', 'Code': 'Code', 'Coursier': 'Courier',
  // The steps
  'Accueil et offre': 'Greeting and offer',
  'Photos': 'Photos',
  'Commande créée': 'Order created',
  'Lien de couverture': 'Cover link',
  'Album construit': 'Album built',
  'Offre de pages': 'Page offer',
  'Vérification par vous': 'Your check',
  'Aperçu 3D envoyé': '3D preview sent',
  'Validation du client': 'Client approval',
  'Offre extras': 'Extras offer',
  'Demande d’avance': 'Advance request',
  'Nom et adresse': 'Name and address',
  'Mode de paiement': 'Payment method',
  'Paiement confirmé': 'Payment confirmed',
  'Impression': 'Printing',
  'Livraison': 'Delivery',
  'Demande d’avis': 'Review request',
  'le premier message est le seul qui donne l’offre': 'the first message is the only one that gives the offer',
  'rien à construire sans photos': 'nothing to build without photos',
  'une commande naît d’un premier échange': 'an order comes from a first exchange',
  'pas de lien de couverture sans commande': 'no cover link without an order',
  'rien à construire sans photos ni commande': 'nothing to build without photos and an order',
  'on compte les pages sur les photos reçues': 'pages are counted on the photos received',
  'on vérifie un album construit': 'you check a built album',
  'le lien n’existe qu’une fois l’album construit': 'the link only exists once the album is built',
  'elle valide ce qu’elle a vu': 'she approves what she has seen',
  'on propose les extras sur un album validé': 'extras are offered on an approved album',
  'on ne demande de l’argent que sur un album validé': 'money is only asked on an approved album',
  'demandé à une cliente déjà en conversation': 'asked of a client already in conversation',
  'le mode de paiement appartient à une commande': 'the payment method belongs to an order',
  'l’argent reste humain : vous validez le reçu': 'money stays human: you approve the receipt',
  'jamais d’impression sans validation, avance et adresse': 'never print without approval, advance and address',
  'on livre un album imprimé': 'a printed album is delivered',
  'on demande un avis sur un album reçu': 'a review is asked on a received album',
  // The panel
  'Étape {n}': 'Step {n}',
  'Retour aux étapes': 'Back to the steps',
  'Message et réglages partagés par les deux onglets. L’ordre et ON/OFF sont propres à chaque onglet.': 'Message and settings shared by both tabs. Order and ON/OFF belong to each tab.',
  'Message': 'Message',
  'Message intégré (aujourd’hui dans le code)': 'Built-in message (in the code today)',
  'Réponse enregistrée « {x} »': 'Saved reply « {x} »',
  'Réutilise une réponse enregistrée du Cerveau — pas de copie.': 'Reuses a saved reply from the Brain — not a copy.',
  'Relances si pas de réponse': 'Reminders if no answer',
  'Aucune': 'None',
  'tout de suite': 'right away',
  'Retirer la relance {h} h': 'Remove the {h} h reminder',
  'Heures après le début de l’étape': 'Hours after the step starts',
  'relance': 'reminder',
  'Jamais la nuit (22 h – 8 h).': 'Never at night (22:00 – 08:00).',
  'Ignorer l’étape si déjà connu': 'Skip the step if already known',
  'Photos déjà reçues': 'Photos already received', 'Nom': 'Name', 'Téléphone': 'Phone', 'Ville': 'City', 'Adresse': 'Address',
  'Pack': 'Pack', 'Titre': 'Title', 'Couverture choisie': 'Cover chosen', 'Commande existante': 'Existing order',
  'Marche aussi sur WhatsApp : une information donnée tôt saute l’étape.': 'Works on WhatsApp too: information given early skips the step.',
  'Doit venir après': 'Must come after',
  'Doit venir avant': 'Must come before',
  'Rien — c’est le début': 'Nothing — it is the start',
  'Pourquoi : {x}.': 'Why: {x}.',
  'Branché sur': 'Wired to',
  'Aucun interrupteur aujourd’hui': 'No switch today',
  'Quand le moteur lira ce processus, l’ON/OFF ici et l’interrupteur des Réglages seront le même.': 'When the engine reads this process, the ON/OFF here and the Settings switch will be the same one.',
  'Réponses de l’IA (Réglages)': 'AI replies (Settings)',
  'Relances photos (Réglages)': 'Photo reminders (Settings)',
  'Relances couverture (Réglages)': 'Cover reminders (Settings)',
  'Relances aperçu (Réglages)': 'Preview reminders (Settings)',
  'Relances paiement (Réglages)': 'Payment reminders (Settings)',
  'Messages d’étape (Réglages)': 'Milestone messages (Settings)',
  'Demande d’avis (Réglages)': 'Review request (Settings)',
  'Créer les commandes (Réglages)': 'Create orders (Settings)',
  'Offre de pages (Réglages)': 'Page offer (Settings)',
  'Vérification avant envoi (Réglages)': 'Check before sending (Settings)',
  'Offre extras (Réglages)': 'Extras offer (Settings)',
  'Livraison — l’agent d’abord (Réglages)': 'Delivery — agent first (Settings)',
  // Step instructions from the Brain
  'Instructions de cette étape': 'This step’s instructions',
  'Tirées du Cerveau. Une modification change l’agent tout de suite ; la liste des instructions liées est gardée avec la version.': 'Taken from the Brain. An edit changes the agent right away; the list of linked instructions is kept with the version.',
  'Aucune instruction liée à cette étape pour l’instant.': 'No instruction linked to this step yet.',
  '{n} instruction(s) liée(s) n’existent plus ou sont désactivées dans le Cerveau.': '{n} linked instruction(s) no longer exist or are turned off in the Brain.',
  'Retirer « {x} » de cette étape': 'Remove « {x} » from this step',
  'Réduire': 'Show less',
  'Tout lire': 'Read all',
  'Instruction': 'Instruction',
  'Enregistrer dans le Cerveau': 'Save to the Brain',
  'Change l’agent tout de suite.': 'Changes the agent right away.',
  'Lecture du Cerveau…': 'Reading the Brain…',
  'Proposer automatiquement': 'Suggest automatically',
  'Lier une instruction du Cerveau': 'Link a Brain instruction',
  'Lier une instruction du Cerveau…': 'Link a Brain instruction…',
  'L’IA ne voit pas d’autre instruction pour cette étape.': 'The AI sees no other instruction for this step.',
  'L’IA propose de lier :': 'The AI suggests linking:',
  'Lier': 'Link',
  'Tout lier ({n})': 'Link all ({n})',
  'Ajouter une instruction': 'Add an instruction',
  'Ex. : demander au moins 20 photos par album, en document.': 'E.g.: ask for at least 20 photos per album, sent as documents.',
  'Vérification…': 'Checking…',
  'Vérifier et fusionner': 'Check and merge',
  'Rien ne change avant « Appliquer ».': 'Nothing changes before « Apply ».',
  'Contradiction': 'Contradiction',
  'Modifier cette règle': 'Edit this rule',
  'Modifiée : « {x} »': 'Changed: « {x} »',
  'Nouvelle instruction : « {x} »': 'New instruction: « {x} »',
  'Appliquer au Cerveau': 'Apply to the Brain',
  'Bloqué : reformulez ou corrigez la règle en conflit, puis vérifiez à nouveau.': 'Blocked: rephrase or fix the conflicting rule, then check again.',
  // Website card
  'Ce que Shopify nous envoie vraiment': 'What Shopify really sends us',
  'Lecture…': 'Reading…',
  'Lecture impossible pour l’instant.': 'Cannot read right now.',
  '{n} commandes du site, 60 derniers jours (lu sans rien modifier).': '{n} website orders, last 60 days (read without changing anything).',
  'Information': 'Information',
  'Remplie': 'Filled',
  'Donc l’étape…': 'So the step…',
  'Pack (Solo / Duo / Trio)': 'Pack (Solo / Duo / Trio)',
  'Titre de l’album': 'Album title',
  'Adresse + ville': 'Address + city',
  'Ville (champ à part)': 'City (separate field)',
  'E-mail': 'Email',
  'texte libre dans la note : demander rue + quartier une fois': 'free text in the note: ask street + neighbourhood once',
  'sautée': 'skipped',
  'jamais envoyé — demandé sur WhatsApp': 'never sent — asked on WhatsApp',
  'parfois — sautée quand présente': 'sometimes — skipped when present',
  'Ancien moteur des commandes du site': 'Old website order engine',
  'tourne en double aujourd’hui': 'runs twice today',
  'Cet onglet le remplace. Il n’est pas supprimé : mis en sommeil, il revient d’un clic.': 'This tab replaces it. It is not deleted: put to sleep, it comes back in one click.',
  'Nouvel interrupteur « Ancien moteur » (ON au départ) — rien ne change tant que vous ne le coupez pas.': 'New « Old engine » switch (ON at first) — nothing changes until you turn it off.',
  'Coupé : plus de nouveau parcours, mais le lien commande ↔ conversation est toujours enregistré.': 'Off: no new journeys, but the order ↔ conversation link is still recorded.',
  'Les parcours en cours sont mis en pause (avec votre OK), jamais effacés.': 'Journeys in progress are paused (with your OK), never deleted.',
  'Ses messages sont repris par cet onglet ; un trou à confirmer : l’accusé « Photos bien reçues ».': 'Its messages are taken over by this tab; one gap to confirm: the « Photos received » acknowledgement.',
  '7 jours de contrôle : aucun nouveau parcours, chaque commande du site a sa conversation.': '7 days of checks: no new journeys, every website order has its conversation.',
  'Retour arrière : rallumer l’interrupteur.': 'To undo: turn the switch back on.',
};
export default m;
